import React from 'react';
import { Box, CircularProgress, useTheme } from '@mui/material';

export default ({ cheers = false }: { cheers?: boolean }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
        [theme.breakpoints.down('md')]: {
          padding: 100,
        },
      }}
    >
      <div>
        {cheers ? (
          <img src="/cheers.gif" alt="loading" height="100px" width="100px" />
        ) : (
          <CircularProgress />
        )}
      </div>
    </Box>
  );
};
